module.exports = __webpack_public_path__ + "img/EAMimg.b7068ec5.png";